import React from 'react'
import utils from '../utils/index'
import storage from '../services/stoage.service'
import '../index.scss'
import { actions as lancamentoPagamentoActions } from '../pages/lancamentoFinanceiroPagamentos/lancamento-pagamentos.actions'
import { actions as lancamentoVendasActions } from '../pages/lancamentoFinanceiroVendas/lancamento-vendas.actions'

import { actions as lancamentoActions } from '../pages/lancamentoFinanceiro/lancamento.actions'
import _ from 'lodash'
import { actions as taxaActions } from '../pages/taxa/taxa.actions'
import { getColumnsLookupPessoa } from './lookupUtils'
import { enums, icons, routes } from '../constants'
import { actions as pessoaActions } from '../pages/pessoa/pessoa.actions'
import { actions as contratoActions } from '../pages/contrato/contrato.actions'
import { actions as nfseActions } from '../pages/nfse/nfse.actions'
import { logarAcesso } from '../services/api-log-acesso'
import { Filtro } from './Filtro'
import { ConfirmDialog } from '../components/confirmDialog/ConfirmDialog'
import BaixarLancamentoDialog from './lancamento/form/dialogs/baixar-lancamento-dialog'
import EmitirNfseDialog from './lancamento/form/dialogs/emitir-nfse-dialog'
import { Dialog } from 'primereact/dialog'
import { Button } from 'primereact/button'
import { Checkbox } from 'primereact/checkbox'
import { InputText } from 'primereact/inputtext'
import ReajustarLancamentoDialog from './lancamento/form/dialogs/reajustar-lancamento-dialog'
import { getValorTaxaManutencaoVigente } from '../services/api-taxa'
import { fuShowFormParcelas } from './lancamento/form/form-render'
import BaixarLancamentoModal from '../pages/lancamentoFinanceiro/baixar-lancamento-modal'

const TIPO_DESCONTO_VALOR = 1
const TIPO_DESCONTO_PERCENTUAL = 2
const TIPO_MULTA_VALOR = 1
const TIPO_MULTA_PERCENTUAL = 2
const TIPO_JUROS_VALOR = 1
const TIPO_JUROS_PERCENTUAL = 2

const getStateToProps = ({ state, crud }) => {
  const messages = state[crud].messages
  const messagesDialog = storage.getAppLabels('dialogs')
  const record = state[crud].currentRecord
  const currentUser = state.appState.currentUser
  const currentCompany = storage.getCompany()
  const currentUnit = storage.getUnit()
  const units = storage.getUnits()

  let disableUnit = false
  if (currentUnit) {
    let unidade = { id: currentUnit.oid, value: currentUnit.sigla }
    Object.assign(record, { unidade: unidade })
    disableUnit = true
  }

  const unidades = utils.getListIdValuesUnidadeDisponiveisUsuario()

  // Se estiver vazio o status
  if (!record.status) {
    Object.assign(record, { status: 1 })
  }
  const taxa = state[crud].currentRecord.taxa

  const pagador = state[crud].currentRecord.pagador
  const lookupPagadorBase = {
    records: state.crudPessoaState.records,
    columns: getColumnsLookupPessoa(state.crudPessoaState.columnsLookup),
    first: state.crudPessoaState.index,
    rows: state.crudPessoaState.max,
    totalRecords: state.crudPessoaState.count,
    sortField: state.crudPessoaState.sortField,
    order: state.crudPessoaState.sortOrder,
    editDisabled: false,
  }
  let lookupPagador = Object.assign({}, state[crud].lookupPagador, lookupPagadorBase)

  const contrato = state[crud].currentRecord.contrato

  let displayForm = {
    pagamento: false,
    parcela: false,
    baixar: false,
    baixarParcelas: false,
    dadosBoletoIndividual: false,
    unirLancamento: false,
    emitirNfse: false,
  }
  if (state[crud].displayForm) {
    displayForm = state[crud].displayForm
  }

  const unidadeLancamento = utils.getUnidadeFromIdValue(currentCompany, record.unidade)
  let fatorMultiplicadorConspaga = utils.getFatorMultiplicadorConspaga(currentCompany, unidadeLancamento)
  if (!fatorMultiplicadorConspaga) {
    fatorMultiplicadorConspaga = 1
  }

  const configFormasPagamento = utils.getConfiguracaoFormasPagamento(currentCompany, unidadeLancamento)
  let formasPagamento = utils.getFormasPagamento(enums.FormasPagamento, configFormasPagamento, record.status)
  const formasPagamentoBasica = utils.getFormasPagamento(
    enums.FormasPagamentoBasica,
    configFormasPagamento,
    record.status
  )
  const servicoCartaoCreditoVindi = utils.isServicoCartaoCreditoVindi(currentCompany, unidadeLancamento)
  const servicoBoletoVindi = utils.isServicoBoletoVindi(currentCompany, unidadeLancamento)
  const exibirConspaga = utils.isExibirConspaga(currentCompany, unidadeLancamento)
  let emitirNotaFiscalServicoManual = false
  const emiteNFSe = utils.isEmiteNFSe(currentCompany, unidadeLancamento)
  if (emiteNFSe) {
    emitirNotaFiscalServicoManual = utils.isEmitirNotaFiscalServicoManual(currentCompany, unidadeLancamento)
  }

  if (!servicoCartaoCreditoVindi) {
    formasPagamento = formasPagamento.filter((fp) => fp.id !== enums.ID_CARTAO_CREDITO_VINDI)
  }
  const formaPagamentoOriginal = state[crud].formaPagamentoOriginal
  const isUsarWebWhatsapp = utils.isUsarWebWhatsapp(currentCompany, unidadeLancamento)
  const adicionandoAnexo = state[crud].adicionandoAnexo
  const contasCorrentesParcelas = state[crud].contasCorrentesParcelas
  const sugerirVendedorLancamento = utils.isSugerirVendedorLancamento(currentCompany, unidadeLancamento)
  const handleDisableSalvar = () => record.status === enums.ID_STATUS_LANCAMENTO_PAGO
  const isAplicarJurosMultaManutencao = utils.isAplicarJurosMultaManutencao(currentCompany, unidadeLancamento)
  const isGerarLancamentoSaldo = utils.isGerarLancamentoSaldo(currentCompany, unidadeLancamento)
  return {
    formaPagamentoOriginal,
    servicoCartaoCreditoVindi,
    servicoBoletoVindi,
    exibirConspaga,
    emiteNFSe,
    emitirNotaFiscalServicoManual,
    formasPagamento,
    formasPagamentoBasica,
    fatorMultiplicadorConspaga,
    displayForm,
    disableUnit,
    unidades,
    currentUser,
    record,
    taxa,
    pagador,
    lookupPagador,
    contrato,
    messages,
    messagesDialog,
    status: [
      { label: 'Em aberto', value: 1 },
      { label: 'Pago', value: 3 },
      { label: 'Cancelado', value: 4 },
    ],
    first: state[crud].index,
    rows: state[crud].max,
    totalRecords: state[crud].count,
    sortField: state[crud].sortField,
    order: state[crud].sortOrder,
    idTela: state[crud].id,
    botoesDinamicos: state[crud].botoesDinamicos,
    pagamento: state[crud].pagamento,
    colunasPagamentos: state[crud].colunasPagamentos,
    selectedParcelas: state[crud].selectedParcelas,
    isSaving: state[crud].isSaving,
    currentCompany,
    currentUnit,
    units,
    stateContrato: state.crudContratoState,
    statePessoaFisica: state.crudPessoaFisicaState,
    statePessoaJuridica: state.crudPessoaJuridicaState,
    stateMarcador: state.crudMarcadorState,
    isUsarWebWhatsapp,
    descontoAplicado: state[crud].descontoAplicado,
    multaAplicada: state[crud].multaAplicada,
    jurosAplicados: state[crud].jurosAplicados,
    valorJurosPadrao: state[crud].valorJurosPadrao,
    valorMultaPadrao: state[crud].valorMultaPadrao,
    percentualJurosPadrao: state[crud].percentualJurosPadrao,
    percentualMultaPadrao: state[crud].percentualMultaPadrao,
    adicionandoAnexo,
    contasCorrentesParcelas,
    sugerirVendedorLancamento,
    handleDisableSalvar,
    isAplicarJurosMultaManutencao,
    descontosMultasJuros: state[crud].descontosMultasJuros,
    isGerarLancamentoSaldo,
  }
}

const mapDispatchToProps = ({ dispatch, actions, basePath }) => {
  return {
    paginate: (paginationParams) => dispatch(actions.paginate(paginationParams)),
    sortOrder: (sortParams) => dispatch(actions.sortOrder(sortParams)),
    applyFilter: (filterParams) => {
      dispatch(actions.setType(null))
      dispatch(actions.applyFilter(filterParams))
    },
    clearFormPagamento: () => dispatch(actions.clearFormPagamento()),
    setField: (field, value) => {
      // CASO FOR A PRIMEIRA TAXA SELECIONADA O RESTANTE DAS TAXAS DEVEM SER OD MESMO GRUPO
      if (field === 'taxas' && utils.isArrayNotEmpty(value) && value.length === 1) {
        let taxa = value[0]
        let novoFiltro = {
          campo: 'tipo',
          valor: taxa.tipo === 'ENTRADA' ? 1 : 2,
          tipoFiltro: 'IGUAL_A',
          relacionamento: ['grupoFinanceiro'],
        }
        dispatch(taxaActions.setFiltroAvancado(novoFiltro))
      } else if (field === 'taxas' && utils.isArrayNullOrEmpty(value)) {
        let novoFiltro = {
          campo: 'tipo',
          tipoFiltro: 'NAO_NULO',
          relacionamento: ['grupoFinanceiro'],
        }
        dispatch(taxaActions.setFiltroAvancado(novoFiltro))
      }
      dispatch(actions.setField(field, value))
    },
    showForm(formName, props) {
      dispatch(actions.setDisplayForm(formName, props))
    },
    changeHandler: (event) => {
      const target = event.target
      const field = target.name
      let valor = target.value
      dispatch(actions.removeErrors([{ field }]))
      if (field === 'unidade') {
        dispatch(actions.setField('unidade', valor))
        dispatch(actions.setField('bandeira', null))
        dispatch(actions.setField('contaCorrente', null))
      } else if (field === 'tipoFormaPagamento' && valor == null) {
        dispatch(actions.setField(field, { id: '', value: '' }))
      } else if (field === 'vencimento' || field === 'dataCompetencia') {
        dispatch(actions.setField(field, valor))
      } else if (field === 'tipoFormaPagamento' && utils.nonNull(valor)) {
        dispatch(actions.setField(field, valor))
      } else if (field === 'promissoria' || field === 'jurosPorDia') {
        dispatch(actions.setField(field, target.checked))
      } else if (
        field === 'valor' ||
        field === 'valorBaixa' ||
        field === 'valorEntrada' ||
        field === 'valorDesconto' ||
        field === 'valorMulta' ||
        field === 'valorJuros' ||
        field === 'valorBruto'
      ) {
        valor = valor.replace('R$', '')
        if (typeof valor === 'string' && valor.length > 0) {
          valor = valor.trim()
        }
        dispatch(actions.setField(field, valor))
      } else if (field === 'tipoDescontoValor' || field === 'tipoDescontoPercentual') {
        dispatch(actions.setField('valorDesconto', ''))
        dispatch(actions.setField('percentualDesconto', ''))
        const tipo = field === 'tipoDescontoValor' ? 1 : 2
        dispatch(actions.setField('tipoDesconto', tipo))
      } else if (field === 'tipoMultaValor' || field === 'tipoMultaPercentual') {
        dispatch(actions.setField('valorMulta', ''))
        dispatch(actions.setField('percentualMulta', ''))
        const tipo = field === 'tipoMultaValor' ? 1 : 2
        dispatch(actions.setField('tipoMulta', tipo))
      } else if (field === 'tipoJurosValor' || field === 'tipoJurosPercentual') {
        dispatch(actions.setField('valorJuros', ''))
        dispatch(actions.setField('percentualJuros', ''))
        const tipo = field === 'tipoJurosValor' ? 1 : 2
        dispatch(actions.setField('tipoJuros', tipo))
      } else {
        dispatch(actions.setField(field, valor))
      }
    },
    clearFormBaixa: () => {
      dispatch(actions.setField('valorPago', ''))
      dispatch(actions.setField('dataPagamento', ''))
    },
    editarPagamento: (pagamento) => {
      Object.keys(pagamento).forEach(function (key) {
        dispatch(actions.setDadoFormaPagamento(key, pagamento[key]))
      })
    },
    editarDadoFormaPagamento: (event) => {
      const target = event.target
      const field = target.name
      let valor = target.value
      if (field === 'valor' || field === 'valorEntrada') {
        valor = valor.replace('R$', '')
        if (typeof valor === 'string' && valor.length > 0) {
          valor = valor.trim()
        }
      }
      // para caso a pessoa mudado de forma de pagamento, mudar a promissoria para false
      if (field === 'formaPagamento' && valor.id !== 7) {
        dispatch(actions.setDadoFormaPagamento('promissoria', false))
      }
      if (field === 'valor') {
        dispatch(actions.setDadoFormaPagamento('valorParcela', valor))
      }
      if (field === 'promissoria') {
        valor = target.checked
      }
      if (field === 'bandeiraEntrada' || field === 'bandeira') {
        valor = { id: valor.oid, value: valor.cartao }
      }
      dispatch(actions.setDadoFormaPagamento(field, valor))
    },
    removerLancamento: (lancamentoRemovido, lancamentos) => {
      let lancamentosAtuais = lancamentos
      let lancamentosRestantes = lancamentosAtuais.filter((lancamento) => {
        if (lancamentoRemovido.hash && lancamentoRemovido.hash !== lancamento.hash) {
          return lancamento
        } else if (lancamentoRemovido.oid && lancamentoRemovido.oid !== lancamento.oid) {
          return lancamento
        }
      })
      setTimeout(() => {
        dispatch(actions.setField('lancamentos', lancamentosRestantes))
      }, 300)
    },
    estornarLancamento: (oidLancamentos) => dispatch(actions.estornarLancamento(oidLancamentos)),
    setDadoFormaPagamento: (field, valor) => {
      dispatch(actions.setDadoFormaPagamento(field, valor))
    },
    adicionarPagamento: (e) => {
      dispatch(actions.gerarParcelas())
    },
    realizarBaixaLancamento: (lancamentos) => dispatch(actions.baixarLancamentos(lancamentos)),
    setSelectedParcelas: (e) => {
      dispatch(actions.setSelectedParcelas(e))
    },
    saveHandler: (event) => {
      dispatch(actions.beforeSave())
      dispatch(actions.save())
    },
    removeHandler: (event) => dispatch(actions.remove()),
    newHandler: (event) => {
      dispatch(actions.makeNew())
      dispatch(actions.clearSelectedParcelas())
      dispatch(actions.getDateTimeFromServer())
    },
    loadById: (oid) => dispatch(actions.loadById(oid)),
    enviarMensagem: (oid, tipoMensagem) => dispatch(actions.enviarMensagem(oid, tipoMensagem)),
    abrirWebWhatsApp: ({ oidLancamento }) => dispatch(actions.abrirWebWhatsApp({ oidLancamento })),
    lookupPagadorSetVisible: (visible) => dispatch(actions.setLookupPagadorVisible(visible)),
    lookupPagadorPaginate: (paginationParams) => dispatch(pessoaActions.paginate(paginationParams)),
    lookupPagadorSortOrder: (sortParams) => dispatch(pessoaActions.sortOrder(sortParams)),
    lookupPagadorApplyFilter: (filterParams) => {
      dispatch(pessoaActions.setFiltroAvancado(filterParams))
      dispatch(pessoaActions.loadLookup())
    },
    lookupPagadorLoad: () => dispatch(pessoaActions.loadLookup()),

    clearSelectedFilters: () => {
      dispatch(taxaActions.clearSelectedFilters())
      dispatch(contratoActions.clearSelectedFilters())
      dispatch(pessoaActions.clearSelectedFilters())
    },
    clearRecords: () => {
      dispatch(taxaActions.setRecords([]))
      dispatch(contratoActions.setRecords([]))
      dispatch(pessoaActions.setRecords([]))
    },
    baixarLancamentos: (lancamentos) => dispatch(actions.baixarLancamentos(lancamentos)),
    getBotoesDinamicos: (idTela) => {
      let tipoTela = Number(enums.TipoTela.FORMULARIO)
      dispatch(actions.getBotoesDinamicos(idTela, tipoTela))
    },
    onClickBotaoDinamico: (listId, oidBotao) => dispatch(actions.executarFuncaoDinamica(listId, oidBotao)),
    gerarBoletoLancamento: (parcela) => dispatch(actions.gerarBoletoLancamento(parcela)),
    gerarBoletoIndividual: (params) => dispatch(actions.gerarBoletoIndividual(params)),
    gerarCarneBoleto: (params) => dispatch(actions.gerarCarneBoleto(params)),
    openUrl: (url) => dispatch(actions.openUrl(url)),
    showMessageConspagaEmDia: (ano) => dispatch(actions.showMessageConspagaEmDia(ano)),
    showMessageTaxaConservacaoJaSelecionada: () => dispatch(actions.showMessageTaxaConservacaoJaSelecionada()),
    downloadDanfe: (oidLancamento) => dispatch(nfseActions.downloadDanfSePorLancamento(oidLancamento)),
    cancelarReabrir: (oidLancamento) => dispatch(actions.cancelarReabrir(oidLancamento)),
    updateObservacaoNota: (grupos, oidContrato, ano, oidTaxa) =>
      dispatch(actions.updateObservacaoNota(grupos, oidContrato, ano, oidTaxa)),
    showWarningMessage: (message) => dispatch(actions.showWarningMessage(message)),
    executarBaixaLancamento: (params) => dispatch(actions.executarBaixaLancamento(params)),
    executarBaixaLancamentos: (params) => dispatch(actions.executarBaixaLancamentos(params)),
    unirLancamentos: (oidLancamentoAtual, oidLancamentoExcluir) =>
      dispatch(actions.unirLancamentos(oidLancamentoAtual, oidLancamentoExcluir)),
    getPacoteTaxas: (taxaSelecionada) => dispatch(actions.getPacoteTaxas(taxaSelecionada)),
    setOidTaxaPrincipal: (oidTaxa) => dispatch(actions.setOidTaxaPrincipal(oidTaxa)),
    getBoletosVindi: ({ oidLancamentoFinanceiro }) => dispatch(actions.getBoletosVindi({ oidLancamentoFinanceiro })),
    // loadCartoesPagador: (oidPagador) => dispatch(actions.loadCartoesPagador(oidPagador)),
    getDateTimeFromServer: () => dispatch(actions.getDateTimeFromServer()),
    setFormaPagamentoOriginal: (value) => dispatch(actions.setFormaPagamentoOriginal(value)),
    // deprecated - usar emitirNotaFiscalServico - PHOENIX-766
    gerarNotaFiscalServico: (oidLancamento) => dispatch(actions.gerarNotaFiscalServico(oidLancamento)),
    emitirNotaFiscalServico: ({ oidLancamento, descricaoNFSe, oidPagador }) =>
      dispatch(actions.emitirNotaFiscalServico({ oidLancamento, descricaoNFSe, oidPagador })),
    findItemLancamento: (tipo, oidTipo, cobertura) => dispatch(actions.findItemLancamento(tipo, oidTipo, cobertura)),
    findItemLancamentoContrato: (tipo, oidTipo, cobertura) =>
      dispatch(actions.findItemLancamentoContrato(tipo, oidTipo, cobertura)),
    consultarStatusPagamentoVindi: (oidLancamentoFinanceiro) =>
      dispatch(actions.consultarStatusPagamentoVindi({ oidLancamentoFinanceiro })),
    consultarStatusPagamentoAilos: (oidLancamentoFinanceiro) =>
      dispatch(actions.consultarStatusPagamentoAilos({ oidLancamentoFinanceiro })),
    consultarStatusPagamentoSicoob: (oidLancamentoFinanceiro) =>
      dispatch(actions.consultarStatusPagamentoSicoob({ oidLancamentoFinanceiro })),
    consultarStatusPagamentoStone: (oidLancamentoFinanceiro) =>
      dispatch(actions.consultarStatusPagamentoStone({ oidLancamentoFinanceiro })),
    gerarCarne: (oidsLancamentoFinanceiro) => dispatch(actions.gerarCarne(oidsLancamentoFinanceiro)),
    getJurosMultaPadrao: (oidLancamentoFinanceiro) => dispatch(actions.getJurosMultaPadrao(oidLancamentoFinanceiro)),
    recalcularValorLancamento: () => dispatch(actions.recalcularValorLancamento()),
    addAnexo(anexo) {
      dispatch(actions.processaAnexo(anexo))
    },
    downloadAnexo(anexo) {
      dispatch(actions.downloadAnexo(anexo))
    },
    removeAnexo(anexo) {
      dispatch(actions.removeAnexo(anexo))
    },
    getContasCorrentesParcelas: () => dispatch(actions.getContasCorrentesParcelas()),
    atualizarProvisionamento: (params) => dispatch(actions.atualizarProvisionamento(params)),
    fecharPedidos: (oidsLancamentos) => dispatch(actions.fecharPedidos(oidsLancamentos)),
    reajustarLancamentos: ({ oidsLancamentos, percentual }) =>
      dispatch(actions.reajustarLancamentos({ oidsLancamentos, percentual, updateRecord: true })),
    getDescontosMultasJuros: (oidsLancamentos) => dispatch(actions.getDescontosMultasJuros(oidsLancamentos)),
  }
}

export function mapStateToPropsLancamentoPagamentos(state) {
  return getStateToProps({ state, crud: 'crudLancamentoPagamentosState' })
}

export function mapStateToPropsLancamentVendas(state) {
  return getStateToProps({ state, crud: 'crudLancamentoVendasState' })
}

export function mapStateToPropsLancamento(state) {
  return getStateToProps({ state, crud: 'crudLancamentoState' })
}

export function mapDispatchToPropsLancamentoPagamentos(dispatch) {
  return mapDispatchToProps({
    dispatch,
    actions: lancamentoPagamentoActions,
    basePath: '/lottustech/lancamentosfinanceirospagamentos',
  })
}

export function mapDispatchToPropsLancamentoVendas(dispatch) {
  return mapDispatchToProps({
    dispatch,
    actions: lancamentoVendasActions,
    basePath: '/lottustech/lancamentosfinanceirosvendas',
  })
}

export function mapDispatchToPropsLancamento(dispatch) {
  return mapDispatchToProps({ dispatch, actions: lancamentoActions, basePath: '/lottustech/lancamentosfinanceiros' })
}

export function fuBeforeFetchRecordSuccess(data) {
  if (data) {
    if (data.valorEntrada) {
      data.valorEntrada = utils.formatCurrency(data.valorEntrada)
    }
    if (data.valorBaixa) {
      data.valorBaixa = utils.formatCurrency(data.valorBaixa)
    }
    if (data.lancamentos && data.lancamentos.length > 0) {
      data.lancamentos.map((lancamentoFilho) => {
        return (lancamentoFilho.valor = utils.formatCurrency(lancamentoFilho.valor))
      })
    }
    if (data.vencimento) {
      data.vencimento = utils.getDateFromNumber(data.vencimento)
    }
    if (data.dataCompetencia) {
      data.dataCompetencia = utils.getDateFromNumber(data.dataCompetencia)
    }
    if (data.dataImportacao) {
      data.dataImportacao = utils.getDateFromNumber(data.dataImportacao)
    }
    if (data.emissao) {
      data.emissao = utils.getDateFromNumber(data.emissao)
    }
    if (data.dataPagamento) {
      data.dataPagamento = utils.getDateFromNumber(data.dataPagamento)
    }
  }
  return data
}

export function fuOnResponseGetPacoteTaxas(taxaSelecionada, pacoteTaxas, formPageContainer) {
  if (utils.isArrayNullOrEmpty(pacoteTaxas)) {
    addTaxa({ newTaxa: taxaSelecionada, formPageContainer })
  } else {
    let valorTaxasPacote = 0
    for (const tx of pacoteTaxas) {
      if (tx.valor) {
        valorTaxasPacote += tx.valor
      }
      addTaxa({ newTaxa: tx, formPageContainer })
    }
    if (taxaSelecionada.valor < valorTaxasPacote) {
      const desconto = valorTaxasPacote - taxaSelecionada.valor
      const e = {
        currentTarget: {
          name: 'valorDesconto',
          defaultValue: desconto,
        },
      }
      formPageContainer.props.setField('tipoDesconto', 1)
      fuOnBlurValorDescontoAcrescimo(e)
    }
  }
  setTimeout(() => {
    formPageContainer.props.setOidTaxaPrincipal(taxaSelecionada.oid)
  }, 200)
}

function addTaxa({ newTaxa, formPageContainer }) {
  let taxasAtuais = formPageContainer.props.record.taxas
  const units = _.get(formPageContainer, 'props.units', storage.getUnits())

  const isTaxaConservacao = utils.isTaxaConservacao(
    units,
    formPageContainer.props.record.unidade.id,
    newTaxa.grupoFinanceiro_oid
  )

  let taxa = {
    taxa: {
      id: newTaxa.oid,
      value: newTaxa.grupoFinanceiro_descricao,
    },
    oidGrupo: newTaxa.grupoFinanceiro_oid,
    value: newTaxa.grupoFinanceiro_descricao,
    valor: utils.formatCurrency(newTaxa.valor),
    tipo: newTaxa.grupoFinanceiro_tipo,
    isTaxaConservacao: isTaxaConservacao,
  }

  if (isTaxaConservacao) {
    updateTaxaCamposConspaga({ record: formPageContainer.props.record, taxa, formPageContainer })
  } else {
    taxa.valorTotal = utils.formatCurrency(newTaxa.valor)
  }

  taxasAtuais.push(taxa)
  fuUpdateObservacaoNota([taxa], formPageContainer)
  formPageContainer.props.setField('taxas', taxasAtuais)
  adicionarValorTaxa(taxa, formPageContainer)
  const habilitou = setFlagHabilitarCamposConspaga(taxasAtuais, formPageContainer)
  updateCamposConspaga(habilitou, formPageContainer.props.record, formPageContainer)
}

function updateTaxaCamposConspaga({ record, taxa, formPageContainer }) {
  let conspagaUltimoPagamento = ''
  let conspagaPagarAte = ''
  if (record && taxa) {
    const anoCorrente = window.moment().year()
    let conspaga
    if (!record.conspaga || parseInt(record.conspaga) === 0) {
      //CONTRATO NOVO - SEM CONSPAGA
      conspaga = anoCorrente // SUGERIMOS ANO ATUAL
    } else {
      conspaga = parseInt(record.conspaga)
    }
    conspagaUltimoPagamento = conspaga
    if (conspaga >= anoCorrente) {
      formPageContainer.props.showMessageConspagaEmDia(conspaga)
    }
    conspagaPagarAte = resolveConspagaPagarAte({ conspagaAtual: conspaga, anoCorrente, formPageContainer })
  }

  taxa.conspagaUltimoPagamento = conspagaUltimoPagamento
  taxa.conspagaPagarAte = conspagaPagarAte
  taxa.valorTotal = utils.formatCurrency(
    calcularValorTaxaConspaga(taxa.valor, conspagaPagarAte, conspagaUltimoPagamento, formPageContainer)
  )
}

function resolveConspagaPagarAte({ conspagaAtual, anoCorrente, formPageContainer }) {
  if (conspagaAtual >= anoCorrente) {
    return conspagaAtual + formPageContainer.props.fatorMultiplicadorConspaga
  }
  if (formPageContainer.props.fatorMultiplicadorConspaga === 1) {
    return anoCorrente
  }
  let result = conspagaAtual
  while (result < anoCorrente) {
    result += formPageContainer.props.fatorMultiplicadorConspaga
  }
  return result
}

function calcularValorTaxaConspaga(valorTaxaConservacao, ateAnoConspaga, conspagaUltimoPagamento, formPageContainer) {
  const valorTaxa = utils.parseStringToNumber(valorTaxaConservacao)
  const anos = ateAnoConspaga - conspagaUltimoPagamento
  return executeCalculaTaxaConservacao(anos, valorTaxa, valorTaxaConservacao, formPageContainer)
}

function executeCalculaTaxaConservacao(anos, valorTaxa, valorDefault, formPageContainer) {
  if (anos > 0) {
    if (formPageContainer.props.fatorMultiplicadorConspaga === 1) {
      const valorConservacaoAtualizado = valorTaxa * anos
      if (valorConservacaoAtualizado && valorConservacaoAtualizado > 0) {
        return valorConservacaoAtualizado
      }
    } else {
      const aux = anos / formPageContainer.props.fatorMultiplicadorConspaga
      if (aux > 0) {
        const valorConservacaoAtualizado = valorTaxa * aux
        if (valorConservacaoAtualizado && valorConservacaoAtualizado > 0) {
          return valorConservacaoAtualizado
        }
      }
    }
  }
  return valorDefault
}

export function fuUpdateObservacaoNota(taxas, formPageContainer) {
  const grupos = taxas.map((f) => f.oidGrupo)
  let oidContrato = null
  let taxa = taxas[0]
  if (utils.isIdValueIdValido(formPageContainer.props.record.contrato)) {
    oidContrato = formPageContainer.props.record.contrato.id
  }
  let oidTaxa = 0
  if (taxa.taxa && taxa.taxa.id) {
    oidTaxa = taxa.taxa.id
  }

  const units = _.get(formPageContainer, 'props.units', storage.getUnits())
  const isTaxaConservacao = utils.isTaxaConservacao(units, formPageContainer.props.record.unidade.id, taxa.oidGrupo)
  let ano = window.moment(formPageContainer.props.record.emissao).year()
  if (isTaxaConservacao) {
    ano = taxa.conspagaPagarAte
  }
  formPageContainer.props.updateObservacaoNota(grupos, oidContrato, ano, oidTaxa)
}

function adicionarValorTaxa(taxa, formPageContainer) {
  const valorTaxa = utils.parseStringToNumber(taxa.valor)
  if (utils.nonNull(taxa) && utils.nonNull(valorTaxa) && utils.isNumber(valorTaxa)) {
    let valorBruto = getValorTaxas(formPageContainer)
    formPageContainer.props.setField('valorBruto', utils.formatCurrency(valorBruto))
    let valorTotalLancamento = fuCalcularValorTotal(utils.parseStringToNumber(valorBruto), formPageContainer)
    if (typeof valorTotalLancamento === 'string') {
      valorTotalLancamento = utils.parseStringToNumber(valorTotalLancamento)
    }
    formPageContainer.props.setField('valor', utils.formatCurrency(valorTotalLancamento))
  }
}

function getValorTaxas(formPageContainer) {
  let taxas = formPageContainer.props.record.taxas
  let valorTotal = 0
  if (taxas && utils.isArrayNotEmpty(taxas)) {
    taxas.forEach((taxa) => {
      let valorTaxa = taxa.valorTotal
      if (utils.nonNull(valorTaxa)) {
        if (typeof valorTaxa === 'string') {
          valorTaxa = utils.parseStringToNumber(valorTaxa)
        }
        if (valorTaxa > 0 && utils.isNumber(valorTaxa)) {
          valorTotal += valorTaxa
        }
      }
    })
  }
  return valorTotal
}

export function fuCalcularValorTotal(valorBruto, formPageContainer) {
  let valorLancamento = valorBruto
  let descontoAplicado = 0
  let tipoDesconto = _.get(formPageContainer, 'props.record.tipoDesconto', '0')
  if (valorLancamento > 0 && parseInt(tipoDesconto) > 0) {
    if (parseInt(tipoDesconto) === 1) {
      // quer dizer que é em R$
      let valorDesconto = utils.parseStringToNumber(formPageContainer.props.record.valorDesconto)
      if (utils.nonNull(valorDesconto) && valorDesconto > 0) {
        descontoAplicado = valorDesconto
      }
    } else if (parseInt(tipoDesconto) === 2) {
      // quer dizer que é em percentual
      let percentualDesconto = utils.parseStringToNumber(formPageContainer.props.record.percentualDesconto)
      if (utils.nonNull(percentualDesconto) && percentualDesconto > 0) {
        let desconto = valorLancamento * percentualDesconto
        desconto = desconto /= 100
        descontoAplicado = desconto
      }
    }
  }

  let multaAplicada = 0
  let tipoMulta = formPageContainer.props.record.tipoMulta
  if (valorLancamento > 0 && parseInt(tipoMulta) > 0) {
    if (tipoMulta === 1) {
      // quer dizer que é em R$
      let valorMulta = utils.parseStringToNumber(formPageContainer.props.record.valorMulta)
      if (utils.nonNull(valorMulta) && valorMulta > 0) {
        multaAplicada = valorMulta
      }
    } else if (tipoMulta === 2) {
      // quer dizer que é em percentual
      let percentualMulta = utils.parseStringToNumber(formPageContainer.props.record.percentualMulta)
      if (utils.nonNull(percentualMulta) && percentualMulta > 0) {
        let valorPercentualMulta = valorLancamento * percentualMulta
        valorPercentualMulta = valorPercentualMulta /= 100
        multaAplicada = valorPercentualMulta
      }
    }
  }

  let jurosAplicados = 0
  let tipoJuros = _.get(formPageContainer, 'props.record.tipoJuros', '0')
  if (valorLancamento > 0 && parseInt(tipoJuros) > 0) {
    if (parseInt(tipoJuros) === 1) {
      // quer dizer que é em R$
      let valorJuros = utils.parseStringToNumber(formPageContainer.props.record.valorJuros)
      if (utils.nonNull(valorJuros) && valorJuros > 0) {
        jurosAplicados = valorJuros
        if (formPageContainer.props.record.jurosPorDia) {
          jurosAplicados *= fuGetDiasEmAtraso(formPageContainer)
        }
      }
    } else if (parseInt(tipoJuros) === 2) {
      // quer dizer que é em percentual
      let percentualJuros = utils.parseStringToNumber(formPageContainer.props.record.percentualJuros)
      if (utils.nonNull(percentualJuros) && percentualJuros > 0) {
        let valorPercentualJuros = valorLancamento * percentualJuros
        valorPercentualJuros = valorPercentualJuros /= 100
        jurosAplicados = valorPercentualJuros
        if (formPageContainer.props.record.jurosPorDia) {
          jurosAplicados *= fuGetDiasEmAtraso(formPageContainer)
        }
      }
    }
  }
  formPageContainer.setState({ multaAplicada: utils.formatCurrency(multaAplicada) })
  formPageContainer.setState({ jurosAplicados: utils.formatCurrency(jurosAplicados) })
  formPageContainer.setState({ descontoAplicado: utils.formatCurrency(descontoAplicado) })
  const valorAtualizado = valorLancamento + (multaAplicada + jurosAplicados - descontoAplicado)
  return utils.formatCurrency(valorAtualizado)
}

export function fuGetDiasEmAtraso(formPageContainer) {
  let diasEmAtraso = 1
  const dataVencimentoLancamento = formPageContainer.props.record.vencimento
  if (dataVencimentoLancamento && utils.isDate(dataVencimentoLancamento)) {
    const dataAtual = window.moment()
    diasEmAtraso = dataAtual.diff(dataVencimentoLancamento, 'days')
  }
  return diasEmAtraso
}

function setFlagHabilitarCamposConspaga(taxas, formPageContainer) {
  //seta a flag que vai habilitar os campos 'conspagaUltimoPagamento' e 'conspagaPagarAte'
  let result = false

  if (utils.isArrayNotEmpty(taxas)) {
    const units = _.get(formPageContainer, 'props.units', storage.getUnits())
    taxas.forEach((taxa) => {
      const isTaxaConservacao = utils.isTaxaConservacao(units, formPageContainer.props.record.unidade.id, taxa.oidGrupo)
      if (isTaxaConservacao) {
        result = true
      }
    })
  }
  formPageContainer.props.setField('habilitarCamposConspaga', result)
  return result
}

function updateCamposConspaga(habilitar, record, formPageContainer) {
  let conspagaUltimoPagamento = ''
  let conspagaPagarAte = ''
  if (habilitar && record) {
    const anoCorrente = window.moment().year()
    let conspaga = 0
    if (!record.conspaga || parseInt(record.conspaga) === 0) {
      //CONTRATO NOVO - SEM CONSPAGA
      conspaga = anoCorrente // SUGERIMOS ANO ATUAL
    } else {
      conspaga = parseInt(record.conspaga)
    }
    conspagaUltimoPagamento = conspaga
    conspagaPagarAte = resolveConspagaPagarAte({ conspagaAtual: conspaga, anoCorrente, formPageContainer })
  }

  formPageContainer.props.setField('conspagaUltimoPagamento', conspagaUltimoPagamento)
  formPageContainer.props.setField('conspagaPagarAte', conspagaPagarAte)
}

export function fuOnBlurValorDescontoAcrescimo(e, formPageContainer) {
  let field = e.currentTarget.name
  let valor = e.currentTarget.defaultValue
  if (typeof valor === 'number') {
    valor = String(valor)
  }
  if (typeof valor === 'string') {
    formPageContainer.props.setField(field, utils.formatCurrency(valor.replace(',', '.').replace('R$', '')))
  }
  let valorBruto = utils.parseStringToNumber(formPageContainer.props.record.valorBruto)
  let valorLancamento = fuCalcularValorTotal(valorBruto, formPageContainer)
  if (typeof valorLancamento === 'string') {
    valorLancamento = utils.parseStringToNumber(valorLancamento)
  }
  formPageContainer.props.setField('valor', valorLancamento)
}

export function fuCalcularValorConspaga(valorLancamento, ateAnoConspaga, formPageContainer) {
  let result = valorLancamento
  if (utils.isArrayNotEmpty(formPageContainer.props.record.taxas)) {
    const taxaConservacao = formPageContainer.props.record.taxas.find((taxa) => {
      const units = _.get(formPageContainer, 'props.units', storage.getUnits())
      return utils.isTaxaConservacao(units, formPageContainer.props.record.unidade.id, taxa.oidGrupo)
    })

    if (taxaConservacao) {
      const valorTaxa = utils.parseStringToNumber(taxaConservacao.valor)
      let anos = 0
      if (!formPageContainer.props.record.conspagaUltimoPagamento) {
        return valorTaxa
      } else {
        anos = ateAnoConspaga - formPageContainer.props.record.conspagaUltimoPagamento
      }
      return executeCalculaTaxaConservacao(anos, valorTaxa, valorLancamento, formPageContainer)
    }
  }
  return result
}

export function fuComponentDidMount(formPageContainer) {
  const oidEntity = _.get(formPageContainer, 'props.match.params.id', null)
  logarAcesso(oidEntity).then()
  if (oidEntity && parseInt(oidEntity)) {
    formPageContainer.props.loadById(oidEntity)
  } else {
    formPageContainer.props.newHandler()
    formPageContainer.props.setField('status', 1)
    const unidade = _.get(formPageContainer, 'props.currentUnit', storage.getUnit())
    if (
      utils.nonNull(formPageContainer.props.location.state) &&
      utils.nonNull(formPageContainer.props.location.state.unidade)
    ) {
      formPageContainer.props.setField('unidade', formPageContainer.props.location.state.unidade)
    } else if (!utils.nonNull(unidade)) {
      resolveUnidadeMatriz(formPageContainer)
    }
    formPageContainer.props.getDateTimeFromServer()
  }
  formPageContainer.props.getContasCorrentesParcelas()
  // this.props.window.addEventListener('resize', this.updateWindowDimensions)
}

function resolveUnidadeMatriz(formPageContainer) {
  const unidade = utils.getIdValueUnidadeMatriz(_.get(formPageContainer, 'props.currentCompany', storage.getCompany()))
  formPageContainer.props.setField('unidade', unidade)
}

export function fuComponentDidUpdate(anteriorProps, formPageContainer) {
  if (anteriorProps.record.oidUnidade === '' && formPageContainer.props.record.unidade) {
    Object.assign(formPageContainer.props.record, {
      oidUnidade: formPageContainer.props.record.unidade.oid,
    })
    Object.assign(formPageContainer.props.record, {
      descricaoUnidade: formPageContainer.props.record.unidade.descricao,
    })
  }
  if (
    anteriorProps.record.vencimento !== formPageContainer.props.record.vencimento &&
    utils.nonNull(formPageContainer.props.record.vencimento) &&
    formPageContainer.props.record.oid === ''
  ) {
    // se alterada data de vencimento, ele já verifica se estaria com uma
    // data anterior, no caso um título vencido
    const emissao = _.get(formPageContainer, 'props.record.emissao')
    const vencimento = _.get(formPageContainer, 'props.record.vencimento')
    const isDateEmissao = utils.isDate(emissao)
    const isDateVencimento = utils.isDate(vencimento)
    const canValidateDatas = isDateEmissao && isDateVencimento && emissao && vencimento
    if (canValidateDatas && window.moment(emissao).isAfter(vencimento, 'day')) {
      formPageContainer.props.showWarningMessage('Data de vencimento anterior a data de emissão.')
    } else {
      if (formPageContainer.props.record.tipoFormaPagamento !== 1) {
        formPageContainer.props.setField('status', 1)
      }
    }
  }
  const vendedor = _.get(formPageContainer.props, 'record.vendedor.id', null)
  const oidLancamento = _.get(formPageContainer.props, 'record.oid', null)
  const sugerirVendedorLancamento = _.get(formPageContainer.props, 'sugerirVendedorLancamento', true)
  if (!vendedor && !_.isNumber(oidLancamento) && sugerirVendedorLancamento) {
    const nomePessoaUsuario = storage.getNomePessoaUsuario()
    const oidPessoaUsuario = storage.getOidPessoaUsuario()
    formPageContainer.props.setField('vendedor', { id: oidPessoaUsuario, value: nomePessoaUsuario })
  }
}

export async function fuOnClickAdicionarParcela(formPageContainer) {
  setTimeout(() => fuShowFormParcelas(formPageContainer), 500)

  const record = _.get(formPageContainer, 'props.record', null)
  if (record) {
    const oid = _.get(record, 'oid', null)
    const isLancamentoManutencao = _.get(record, 'lancamentoManutencao', false)
    const tipoItemPrincipal = _.get(record, 'tipoItemPrincipal', '')
    const oidItemPrincipal = _.get(record, 'oidItemPrincipal', null)
    const oidUnidade = _.get(record, 'unidade.id', null)
    let valorTaxaManutencaoVigente = 0
    let valorParcela = 0
    if ((oid && isLancamentoManutencao) || (tipoItemPrincipal === 'TAXA' && oidItemPrincipal)) {
      const apiResponse = await getValorTaxaManutencaoVigente(oidItemPrincipal, oidUnidade)
      if (apiResponse.status === 200) {
        valorTaxaManutencaoVigente = apiResponse.data
        const taxas = _.get(record, 'taxas', [])
        const taxa = taxas.find((t) => parseInt(_.get(t, 'itemLancamento.oidTipo', '0')) === parseInt(oidItemPrincipal))
        const quantidade = _.get(taxa, 'quantidade', 1)
        valorParcela = valorTaxaManutencaoVigente * quantidade
      }
    }
    fuCalcularValorParcela(formPageContainer, valorParcela)
  }
}

export function fuCalcularValorParcela(formPageContainer, valorTaxaManutencaoVigente = 0) {
  let result = 0
  let valorTotalLancamento =
    valorTaxaManutencaoVigente > 0
      ? valorTaxaManutencaoVigente
      : utils.parseStringToNumber(formPageContainer.props.record.valor)

  result += valorTotalLancamento
  if (valorTotalLancamento && valorTotalLancamento !== '') {
    // valor da entrada individual que pode ser dada no título
    let valorEntrada = utils.parseStringToNumber(formPageContainer.props.pagamento.valorEntrada)
    if (valorEntrada && valorEntrada !== '') {
      result -= valorEntrada
    }

    // valor subtraido de cada título filho do lancamento
    let lancamentos = formPageContainer.props.record.lancamentos
    if (utils.isArrayNotEmpty(formPageContainer.props.record.lancamentos)) {
      lancamentos.forEach((lancamento) => {
        let valorLancamentoFilho = utils.parseStringToNumber(lancamento.valor)
        if (result > 0 && valorLancamentoFilho > 0) {
          result -= valorLancamentoFilho
        }
      })
    }
    formPageContainer.props.setDadoFormaPagamento('valor', utils.formatCurrency(result))
    // caso informado numero de parcelas realiza o calculo do valor da parcela
    let numeroParcelas = formPageContainer.props.pagamento.numeroParcelas
    if (numeroParcelas > 1) {
      result = Math.round((result * 100) / numeroParcelas) / 100
    }
  }
  formPageContainer.props.setDadoFormaPagamento('valorParcela', utils.formatCurrency(result))
  formPageContainer.setState({ atualizar: true })
}

export function fuAfterLoad(formPageContainer) {
  const tipoFormaPagamento = _.get(formPageContainer, 'props.record.tipoFormaPagamento', null)
  if (tipoFormaPagamento) {
    formPageContainer.props.setFormaPagamentoOriginal(tipoFormaPagamento)
  }
  formPageContainer.props.getJurosMultaPadrao(_.get(formPageContainer, 'props.record.oid', null))

  fuCalcularValorParcela(formPageContainer)
  fuOrdenarArrayParcelas(formPageContainer)
  if (formPageContainer.props.record.oid) {
    fuRecalcularValorLancamento(formPageContainer)
  }
}

export function fuOrdenarArrayParcelas(formPageContainer) {
  let lancamentosOrdenados = utils.orderArrayByProperty(formPageContainer.props.record.lancamentos, 'vencimento')
  if (!utils.isArrayNullOrEmpty(lancamentosOrdenados)) {
    formPageContainer.props.setField('lancamentos', lancamentosOrdenados)
  }
}

export function fuAfterNew(formPageContainer, basePath) {
  formPageContainer.props.history.push(`${basePath}/novo`)
  formPageContainer.props.clearSelectedFilters()
  resolveUnidadeMatriz(formPageContainer)
  // caso tenha vindo de um contrato deve pegar os seguintes parametros
  if (utils.nonNull(formPageContainer.props.location.state)) {
    formPageContainer.props.setField('vendedor', formPageContainer.props.location.state.vendedor)
    formPageContainer.props.setField('auxiliar', formPageContainer.props.location.state.auxiliar)
    if (utils.nonNull(formPageContainer.props.location.state.contrato)) {
      formPageContainer.props.setField('conspaga', formPageContainer.props.location.state.conspaga)
      formPageContainer.props.setField('contrato', formPageContainer.props.location.state.contrato)
    }
    if (utils.nonNull(formPageContainer.props.location.state.responsavel)) {
      formPageContainer.props.setField('pagador', formPageContainer.props.location.state.responsavel)
    }
    if (utils.nonNull(formPageContainer.props.location.state.tipoFormaPagamento)) {
      formPageContainer.props.setField('tipoFormaPagamento', formPageContainer.props.location.state.tipoFormaPagamento)
      formPageContainer.props.setField('valorBruto', formPageContainer.props.location.state.valor)
      formPageContainer.props.setField('codigoAgencia', formPageContainer.props.location.state.codigoAgencia)
      formPageContainer.props.setField('codigoConta', formPageContainer.props.location.state.codigoConta)

      const dataCompetencia = utils.getDateFromNumber(formPageContainer.props.location.state.dataCompetencia)
      formPageContainer.props.setField('dataCompetencia', dataCompetencia)

      if (formPageContainer.props.location.state.unidadeConsumidora && dataCompetencia) {
        formPageContainer.props.setField(
          'observacao',
          formPageContainer.props.location.state.unidadeConsumidora +
            '-' +
            (dataCompetencia.getMonth() + 1) +
            '/' +
            dataCompetencia.getFullYear()
        )
      }

      if (
        formPageContainer.props.location.state.coberturas &&
        formPageContainer.props.location.state.coberturas.length > 0
      ) {
        for (const cobertura of formPageContainer.props.location.state.coberturas) {
          formPageContainer.props.findItemLancamentoContrato(
            cobertura.itemLancamento.tipo,
            cobertura.itemLancamento.oidTipo,
            cobertura
          )
        }
      }
      fuRecalcularValorLancamento(formPageContainer)
    }
  }
}

export function fuRecalcularValorLancamento(formPageContainer) {
  const isLancamentoManutencao = _.get(formPageContainer, 'props.record.lancamentoManutencao', false)
  const isAplicarJurosMultaManutencao = _.get(formPageContainer, 'props.isAplicarJurosMultaManutencao', true)
  if ((isAplicarJurosMultaManutencao && isLancamentoManutencao) || !isLancamentoManutencao) {
    setTimeout(() => {
      formPageContainer.props.recalcularValorLancamento()
    }, 200)
  }
}

export function fuEditarNumeroParcelas(e, formPageContainer) {
  formPageContainer.props.editarDadoFormaPagamento(e)
  setTimeout(() => {
    fuCalcularValorParcela(formPageContainer)
  }, 200)
}

export function fuOnBlurValorFormaPagamento(lancamento, e, formPageContainer) {
  let field = e.currentTarget.name
  let valor = e.currentTarget.defaultValue
  if (typeof valor === 'number') {
    valor = String(valor)
  }
  lancamento[field] = utils.formatCurrency(valor.replace(',', '.').replace('R$', ''))
  fuCalcularValorParcela(formPageContainer)
}

export function fuOnBlurValorParcela(e, formPageContainer) {
  let valor = e.currentTarget.defaultValue
  if (typeof valor === 'number') {
    valor = String(valor)
  }
  formPageContainer.props.pagamento.valorParcela = utils.formatCurrency(valor.replace(',', '.').replace('R$', ''))
}

export function fuOnBlurNumeroParcelas(e, formPageContainer) {
  let numeroParcelas = e.currentTarget.defaultValue
  calcularParcelas(numeroParcelas, formPageContainer)
}

function calcularParcelas(nr, formPageContainer) {
  const ve = formPageContainer.props.record.valorEntrada
  const vl = formPageContainer.props.record.valor
  let valorLancamento = utils.parseCurrency(vl)
  let numeroParcelas = utils.parseCurrency(nr)
  if (valorLancamento > 0) {
    let valorRestante = valorLancamento
    let valorEntrada = utils.parseCurrency(ve)
    if (utils.isNumber(valorEntrada)) {
      valorRestante = valorLancamento - valorEntrada
    }
    if (valorRestante > 0) {
      if (numeroParcelas && numeroParcelas > 0) {
        let parcelamento = utils.getValorParcelas(valorRestante, numeroParcelas)
        formPageContainer.props.setField('valorParcela', parcelamento.parcelas)
      }
    }
  }
}

export function fuChangeHandlerValorLancamento(e, formPageContainer) {
  formPageContainer.props.changeHandler(e)
  let valorBruto = utils.parseStringToNumber(formPageContainer.props.record.valorBruto)
  let valorTotalLancamento = fuCalcularValorTotal(valorBruto, formPageContainer)
  if (typeof valorTotalLancamento === 'string') {
    valorTotalLancamento = utils.parseStringToNumber(valorTotalLancamento)
  }
  formPageContainer.props.setField('valor', valorTotalLancamento)
}

export function fuOnChangeJurosDia(e, formPageContainer) {
  formPageContainer.props.setField('valorJuros', 0)
  formPageContainer.props.setField('percentualJuros', 0)
  const checked = _.get(e, 'target.checked', false)
  formPageContainer.props.setField('jurosPorDia', checked)
  fuRecalcularValorLancamento(formPageContainer)
}

export function fuOnChangeTipoDesconto(event, formPageContainer) {
  const name = _.get(event, 'target.name', '')
  const value = name === 'tipoDescontoValor' ? TIPO_DESCONTO_VALOR : TIPO_DESCONTO_PERCENTUAL
  formPageContainer.props.setField('tipoDesconto', value)
  formPageContainer.props.setField('valorDesconto', 0)
  formPageContainer.props.setField('percentualDesconto', 0)
  fuRecalcularValorLancamento(formPageContainer)
}

export function fuOnChangeValorDesconto(value, formPageContainer) {
  if (value < 0) {
    value = 0
  }
  formPageContainer.props.setField('valorDesconto', value)
  formPageContainer.props.setField('percentualDesconto', 0)
  fuRecalcularValorLancamento(formPageContainer)
}

export function fuOnChangePercentualDesconto(value, formPageContainer) {
  if (value < 0) {
    value = 0
  }
  formPageContainer.props.setField('percentualDesconto', value)
  formPageContainer.props.setField('valorDesconto', 0)
  fuRecalcularValorLancamento(formPageContainer)
}

export function fuOnChangeTipoMulta(event, formPageContainer) {
  const name = _.get(event, 'target.name', '')
  const value = name === 'tipoMultaValor' ? TIPO_MULTA_VALOR : TIPO_MULTA_PERCENTUAL
  formPageContainer.props.setField('tipoMulta', value)
  formPageContainer.props.setField('valorMulta', formPageContainer.props.valorMultaPadrao)
  formPageContainer.props.setField('percentualMulta', formPageContainer.props.percentualMultaPadrao)
  fuRecalcularValorLancamento(formPageContainer)
}

export function fuOnChangeValorMulta(value, formPageContainer) {
  if (value < 0) {
    value = 0
  }
  formPageContainer.props.setField('valorMulta', value)
  formPageContainer.props.setField('percentualMulta', 0)
  fuRecalcularValorLancamento(formPageContainer)
}

export function fuOnChangePercentualMulta(value, formPageContainer) {
  if (value < 0) {
    value = 0
  }
  formPageContainer.props.setField('percentualMulta', value)
  formPageContainer.props.setField('valorMulta', 0)
  fuRecalcularValorLancamento(formPageContainer)
}

export function fuOnChangeTipoJuros(event, formPageContainer) {
  const name = _.get(event, 'target.name', '')
  const value = name === 'tipoJurosValor' ? TIPO_JUROS_VALOR : TIPO_JUROS_PERCENTUAL
  formPageContainer.props.setField('tipoJuros', value)
  formPageContainer.props.setField('valorJuros', formPageContainer.props.valorJurosPadrao)
  formPageContainer.props.setField('percentualJuros', formPageContainer.props.percentualJurosPadrao)
  fuRecalcularValorLancamento(formPageContainer)
}

export function fuOnChangeValorJuros(value, formPageContainer) {
  if (value < 0) {
    value = 0
  }
  const jurosPorDiaLancamentoNaoVencido = isJurosPorDiaLancamentoNaoVencido(formPageContainer)
  if (jurosPorDiaLancamentoNaoVencido) {
    value = 0
  }
  setTimeout(() => {
    formPageContainer.props.setField('valorJuros', value)
    formPageContainer.props.setField('percentualJuros', 0)
    fuRecalcularValorLancamento(formPageContainer)
  }, 150)
}

function isJurosPorDiaLancamentoNaoVencido(formPageContainer) {
  const jurosDia = _.get(formPageContainer, 'props.record.jurosPorDia', false)
  const diasAtraso = fuGetDiasEmAtraso(formPageContainer)
  return jurosDia && diasAtraso <= 0
}

export function fuOnChangePercentualJuros(value, formPageContainer) {
  if (value < 0) {
    value = 0
  }
  formPageContainer.props.setField('percentualJuros', value)
  formPageContainer.props.setField('valorJuros', 0)
  fuRecalcularValorLancamento(formPageContainer)
}

export function fuOnBlurConspagaPagarAte(e, formPageContainer) {
  const taxaConservacao = formPageContainer.props.record.taxas.find((taxa) => {
    const units = _.get(formPageContainer, 'props.units', storage.getUnits())
    return utils.isTaxaConservacao(units, formPageContainer.props.record.unidade.id, taxa.oidGrupo)
  })
  fuUpdateObservacaoNota([taxaConservacao], formPageContainer)
}

export function fuOnChangeHandlerConspagaPagarAte(taxa, e, formPageContainer) {
  const target = e.target
  const field = target.name
  const conspagaPagarAte = _.defaultTo(parseInt(target.value), 0)
  taxa[field] = conspagaPagarAte
  formPageContainer.setState({ atualizar: true })
  let valorLancamento = utils.parseStringToNumber(formPageContainer.props.record.valorBruto)
  if (
    !formPageContainer.props.record.lancamentoOrigem ||
    parseInt(formPageContainer.props.record.lancamentoOrigem) === 0
  ) {
    let valorTotal = fuCalcularValorConspaga(valorLancamento, conspagaPagarAte, formPageContainer)
    taxa.valorTotal = utils.formatCurrency(valorTotal)
    valorTotal += somarValorTaxasSemConservacao()
    let valor = utils.formatCurrency(valorTotal)
    formPageContainer.props.setField('valorBruto', valor)
    let valorTotalLancamento = fuCalcularValorTotal(utils.parseStringToNumber(valor), formPageContainer)
    if (typeof valorTotalLancamento === 'string') {
      valorTotalLancamento = utils.parseStringToNumber(valorTotalLancamento)
    }
    formPageContainer.props.setField('valor', utils.formatCurrency(valorTotalLancamento))
  }
}

function somarValorTaxasSemConservacao(formPageContainer) {
  let valorTotal = 0
  const taxas = _.get(formPageContainer, 'props.record.taxas', [])
  if (utils.isArrayNotEmpty(taxas)) {
    const taxaConservacao = taxas.find((taxa) => {
      const units = _.get(formPageContainer, 'props.units', storage.getUnits())
      return utils.isTaxaConservacao(units, formPageContainer.props.record.unidade.id, taxa.oidGrupo)
    })

    taxas.forEach((t) => {
      if (t.taxa.id !== taxaConservacao.taxa.id) {
        valorTotal += utils.parseStringToNumber(t.valor)
      }
    })
  }
  return valorTotal
}

export function fuChangeHandlerFormaPagamento(event, formPageContainer) {
  const target = event.target
  const id = _.get(target, 'value.id', -1)
  // caso a forma de pagamento for 6 - dinheiro, 7 - Credito ou 8 - Debito, deve sugerir a data de vencimento para hoje.
  if ((id === 6 || id === 7 || id === 8) && !formPageContainer.props.record.vencimento) {
    formPageContainer.props.setField('vencimento', new Date())
  }
  formPageContainer.props.changeHandler(event)
  formPageContainer.props.setField('bandeira', null)
}

export function fuLookupPagadorOnPage(e, formPageContainer) {
  formPageContainer.props.lookupPagadorPaginate({
    max: e.rows,
    index: e.first,
  })
}

export function fuLookupPagadorOnSort(e, formPageContainer) {
  formPageContainer.props.lookupPagadorSortOrder({
    sortOrder: e.sortOrder,
    sortField: e.sortField,
  })
}

export function fuLookupPagadorOnFilter(e, formPageContainer) {
  let isFilterApplied = false
  const keys = Object.keys(e.filters) || []
  keys.forEach((key) => {
    const value = e.filters[key].value
    if (value) {
      const filter = {
        campo: key,
        valor: value,
        tipoFiltro: 'CONTEM',
      }
      formPageContainer.props.lookupPagadorApplyFilter(filter)
      isFilterApplied = true
    }
  })

  if (!isFilterApplied) {
    formPageContainer.props.clearSelectedFilters()
    formPageContainer.props.lookupPagadorLoad()
  }
}

export function fuLookupPagadorOnClick(e, formPageContainer) {
  formPageContainer.props.clearSelectedFilters()
  formPageContainer.props.lookupPagadorLoad()
  formPageContainer.props.lookupPagadorSetVisible(true)
}

export function fuLookupPagadorOnHide(e, formPageContainer) {
  formPageContainer.props.lookupPagadorSetVisible(false)
}

export function fuLookupPagadorOnConfirm(e, formPageContainer) {
  fuSetFieldPagador(e.selection.oid, e.selection.nome, e.selection.numeroDocumento, formPageContainer)
  formPageContainer.props.lookupPagadorSetVisible(false)
  fuCheckDocumentoPagador(e.selection.numeroDocumento, formPageContainer)
}

export function fuSetFieldPagador(oid, nome, numeroDocumento, formPageContainer) {
  formPageContainer.props.setField('pagador.id', oid)
  formPageContainer.props.setField('pagador.value', nome)
  if (numeroDocumento && numeroDocumento.length > 11) {
    formPageContainer.props.setField('pagadorPessoaFisica', false)
  } else {
    formPageContainer.props.setField('pagadorPessoaFisica', true)
  }
}

export function fuCheckDocumentoPagador(value, formPageContainer) {
  if (!value || value === '00000000000' || value === '00000000000000') {
    formPageContainer.props.showWarningMessage(
      'O pagador selecionado não possui um CPF/CNPJ válido. Essa informação é obrigatória para geração da nota fiscal.'
    )
  }
}

export function fuLookupPagadorOnCancel(e, formPageContainer) {
  formPageContainer.props.lookupPagadorSetVisible(false)
}

export function fuLookupPagadorOnEdit(formPageContainer) {
  if (
    formPageContainer.props.record.pagador &&
    formPageContainer.props.record.pagador.id &&
    formPageContainer.props.record.pagadorPessoaFisica
  ) {
    return `${routes.PATH_PESSOA_FISICA}/${formPageContainer.props.record.pagador.id}`
  }
  if (
    formPageContainer.props.record.pagador &&
    formPageContainer.props.record.pagador.id &&
    !formPageContainer.props.record.pagadorPessoaFisica
  ) {
    return `${routes.PATH_PESSOA_JURIDICA}/${formPageContainer.props.record.pagador.id}`
  }
  return `${routes.PATH_PESSOA_FISICA}`
}

export function fuLookupPagadorOnInputFilter(e, formPageContainer) {
  const value = e.value
  if (typeof value === 'string') {
    formPageContainer.props.setField('pagador.id', null)
    formPageContainer.props.setField('pagador.value', e.value)
    formPageContainer.props.clearRecords()
  } else {
    fuSetFieldPagador(e.value.oid, e.value.nome, e.value.numeroDocumento, formPageContainer)
    const filters = {}
    formPageContainer.props.lookupPagadorApplyFilter(filters)
    fuCheckDocumentoPagador(e.value.numeroDocumento, formPageContainer)
  }
}

export function fuLookupPagadorOnKeyPress(e, formPageContainer) {
  if (
    utils.nonNull(formPageContainer.props.record.pagador) &&
    utils.nonNull(formPageContainer.props.record.pagador.value)
  ) {
    const filtroNome = new Filtro('nome', formPageContainer.props.record.pagador.value, 'CONTEM')
    const filtroCpf = new Filtro('numeroDocumento', formPageContainer.props.record.pagador.value, 'CONTEM')
    const filtros = []
    filtros.push(filtroNome)
    filtros.push(filtroCpf)
    const filtroOu = {
      campo: 'filtro',
      valor: filtros,
      tipoFiltro: 'OU',
    }
    formPageContainer.props.lookupPagadorApplyFilter(filtroOu)
  }
}

export function fuSetContrato(data, formPageContainer) {
  const oid = _.get(data, 'oid', null)
  const conspaga = _.get(data, 'conspaga', '')
  const numero = _.get(data, 'numero', '')
  let valor = _.get(data, 'localizacao_identificacao', '')
  if (!valor) {
    valor = '#' + (numero || oid) + ' - ' + _.get(data, 'tipoSepultura.descricao', '')
  }

  formPageContainer.props.setField('conspaga', conspaga)
  formPageContainer.props.setField('contrato.id', oid)
  formPageContainer.props.setField('contrato.value', valor)

  fuSetFieldPagador(data.responsavel_oid, data.responsavel_nome, data.responsavel_numeroDocumento, formPageContainer)
}

export function fuSetNotaEntrada(data, formPageContainer) {
  const oid = _.get(data, 'oid', null)
  const numero = _.get(data, 'numero', '')
  const serie = _.get(data, 'serie', '')

  let valor = numero
  if (oid) {
    valor = `${numero} - ${serie}`
  }
  formPageContainer.props.setField('notaEntrada.id', oid)
  formPageContainer.props.setField('notaEntrada.value', valor)
}

export function fuSetContaCorrente(data, formPageContainer) {
  const oid = _.get(data, 'oid', null)
  const descricao = _.get(data, 'descricao', '')

  formPageContainer.props.setField('contaCorrente.id', oid)
  formPageContainer.props.setField('contaCorrente.value', descricao)
}

export function fuHideDialog(formPageContainer) {
  formPageContainer.setState({ showDialogRemove: false })
  formPageContainer.setState({ showConfirmarUnirLancamento: false })
  formPageContainer.setState({ showConfirmarCancelarReabrir: false })
  formPageContainer.setState({ showConfirmarEstornarParcelas: false })
  formPageContainer.setState({ showConfirmarEstornar: false })
  formPageContainer.setState({ showConfirmarFecharPedido: false })
  formPageContainer.setState({ showConfirmarReajusteLancamento: false })
}

export function fuRealizarBaixaLancamentosFilhos(formPageContainer) {
  if (
    formPageContainer.props.selectedParcelas &&
    formPageContainer.props.selectedParcelas.length > 0 &&
    formPageContainer.props.record.dataPagamentoParcela
  ) {
    formPageContainer.props.selectedParcelas.forEach((lancamento) => {
      lancamento.dataPagamento = formPageContainer.props.record.dataPagamentoParcela
      lancamento.valor = utils.parseStringToNumber(lancamento.valor)
      lancamento.valorPago = lancamento.valor
    })
    formPageContainer.props.baixarLancamentos(formPageContainer.props.selectedParcelas)
  }
}

export function fuRealizarBaixaLancamento(formPageContainer) {
  formPageContainer.props.record.valor = utils.parseStringToNumber(formPageContainer.props.record.valor)
  formPageContainer.props.record.valorPago = formPageContainer.props.record.valor
  delete formPageContainer.props.record.dataPagamentoParcela
  formPageContainer.props.realizarBaixaLancamento([formPageContainer.props.record])
}

export function fuOnClickBaixarButton(formPageContainer) {
  //FIXME usar setState
  formPageContainer.state.paramBaixarLancamento.oidLancamento = formPageContainer.props.record.oid
  formPageContainer.state.paramBaixarLancamento.valorPago = formPageContainer.props.record.valor
  formPageContainer.state.paramBaixarLancamento.dataPagamento = new Date()
  formPageContainer.state.paramBaixarLancamento.formaPagamento = formPageContainer.props.record.tipoFormaPagamento
  formPageContainer.props.showForm('baixar', true)
}

export function fuExecutarBaixaLancamento(formPageContainer) {
  const params = formPageContainer.state.paramBaixarLancamento
  if (utils.isFormaPagamentoSeguradora(params.formaPagamento)) {
    formPageContainer.props.showWarningMessage(
      "Forma de pagamento 'Seguradora' não é permitida para a baixa. Selecione outra e tente outra vez."
    )
  } else {
    formPageContainer.props.executarBaixaLancamento(formPageContainer.state.paramBaixarLancamento)
  }
}

export function fuVerificarGeracaoBoletoIndividual(lancamento, formPageContainer) {
  const isBoletoVindi = _.get(lancamento, 'lancamentoVindi', false)
  const fnGetBoletosVindi = _.get(formPageContainer, 'props.getBoletosVindi', null)
  if (isBoletoVindi && fnGetBoletosVindi) {
    fnGetBoletosVindi({ oidLancamentoFinanceiro: lancamento.oid })
    return
  }

  formPageContainer.setState({ oidLancamentoBoletoIndividual: lancamento.oid })
  // caso já tem boleto gerado não deve mostrar novamente os dados para envio do boleto
  const oidBoletoAilos = _.get(lancamento, 'oidBoletoAilos', null)
  if (oidBoletoAilos) {
    formPageContainer.props.gerarBoletoIndividual({
      oidsLancamentosFinanceiros: [lancamento.oid],
    })
  } else {
    formPageContainer.props.showForm('dadosBoletoIndividual', true)
  }
}

export function fuConsultarStatusPagamento(lancamento, formPageContainer) {
  const oid = _.get(lancamento, 'oid', null)
  if (!oid) {
    return
  }
  const isLancamentoVindi = _.get(lancamento, 'lancamentoVindi', false)
  if (isLancamentoVindi) {
    formPageContainer.props.consultarStatusPagamentoVindi(oid)
  }

  const isLancamentoAilos = _.get(lancamento, 'lancamentoAilos', false)
  if (isLancamentoAilos) {
    formPageContainer.props.consultarStatusPagamentoAilos(oid)
  }

  const isLancamentoSicoob = _.get(lancamento, 'lancamentoSicoob', false)
  if (isLancamentoSicoob) {
    formPageContainer.props.consultarStatusPagamentoSicoob(oid)
  }

  const isLancamentoStone = _.get(lancamento, 'lancamentoStone', false)
  if (isLancamentoStone) {
    formPageContainer.props.consultarStatusPagamentoStone(oid)
  }
}

export function fuGerarCarneIndividual(lancamento, formPageContainer) {
  if (lancamento && lancamento.oid) {
    formPageContainer.props.gerarCarne([lancamento.oid])
  }
}

export function fuGetBotoesPersonalizados(formPageContainer) {
  const permissoes = utils.getPermissoesPorMenu(
    storage.getMenus(),
    storage.getOidCurrentMenu(),
    formPageContainer.props.location.pathname,
    storage.getPortalCliente()
  )
  const somenteLeitura = permissoes && !permissoes.alterar

  const arrayBotoes = []
  const lancamento = formPageContainer.props.record
  const urlPromissoria = _.get(lancamento, 'urlPromissoria', '')
  if (utils.isStringNotBlank(urlPromissoria)) {
    const botao = {
      type: 'button',
      label: utils.getMessage(formPageContainer.props.messages, 'lancamentofinanceiro.label.promissoria'),
      onClick: (e) => formPageContainer.props.openUrl(urlPromissoria),
      icon: icons.RECEIPT_ICON,
    }
    arrayBotoes.push(botao)
  }
  const urlRecibo = _.get(lancamento, 'urlRecibo', '')
  const urlReciboPdf = _.get(lancamento, 'urlReciboPdf', '')
  const lancamentoContrapartida = parseInt(_.get(lancamento, 'lancamentoContrapartida', '0')) > 0
  if (!_.isEmpty(urlRecibo) && !lancamentoContrapartida) {
    const model = []
    if (!_.isEmpty(urlReciboPdf)) {
      const botao = {
        label: 'Visualizar',
        command: (e) => formPageContainer.props.openUrl(urlReciboPdf),
        icon: icons.RECEIPT_ICON,
      }
      model.push(botao)
    }
    const botao = {
      type: 'split',
      label: 'Recibo',
      icon: icons.RECEIPT_ICON,
      model,
      onClick: (e) => formPageContainer.props.openUrl(urlRecibo),
    }
    arrayBotoes.push(botao)
  }
  if (
    lancamento.oid &&
    lancamento.lancamentos.length === 0 &&
    lancamento.status !== 3 && //PAGO
    lancamento.status !== 4 //CANCELADO
  ) {
    const isBoleto = _.get(lancamento, 'tipoFormaPagamento.id', -1) === 5
    if (isBoleto) {
      const botao = {
        type: 'button',
        label: utils.getMessage(formPageContainer.props.messages, 'lancamentofinanceiro.label.boleto'),
        onClick: (e) => {
          fuVerificarGeracaoBoletoIndividual(lancamento, formPageContainer)
        },
        icon: icons.CREDIT_CARD_ICON,
      }
      arrayBotoes.push(botao)
    }
    const isLancamentoVindi = _.get(lancamento, 'lancamentoVindi', false)
    const isLancamentoAilos = _.get(lancamento, 'lancamentoAilos', false)
    const isLancamentoSicoob = _.get(lancamento, 'lancamentoSicoob', false)
    const isLancamentoStone = _.get(lancamento, 'lancamentoStone', false)
    if (isLancamentoVindi || isLancamentoAilos || isLancamentoSicoob || isLancamentoStone) {
      const botaoConsultarStatus = {
        type: 'button',
        label: utils.getMessage(
          formPageContainer.props.messages,
          'lancamentofinanceiro.label.consultarStatusPagamento'
        ),
        onClick: (e) => {
          fuConsultarStatusPagamento(lancamento, formPageContainer)
        },
        icon: icons.SEARCH_ICON,
      }
      arrayBotoes.push(botaoConsultarStatus)
    }
  }

  if (
    lancamento.oid &&
    lancamento.lancamentos.length === 0 &&
    lancamento.status !== 3 && //PAGO
    lancamento.status !== 4 && //CANCELADO
    lancamento.tipoFormaPagamento &&
    lancamento.tipoFormaPagamento.id === 17 //Carne
  ) {
    const botao = {
      type: 'button',
      label: utils.getMessage(formPageContainer.props.messages, 'lancamentofinanceiro.label.carne'),
      onClick: (e) => {
        fuGerarCarneIndividual(lancamento, formPageContainer)
      },
      icon: icons.CREDIT_CARD_ICON,
    }
    arrayBotoes.push(botao)
  }
  if (
    lancamento.oid &&
    lancamento.lancamentos.length === 0 &&
    lancamento.status !== 3 &&
    lancamento.status !== 4 &&
    !somenteLeitura
  ) {
    const botao = {
      type: 'button',
      label: utils.getMessage(formPageContainer.props.messages, 'lancamentofinanceiro.label.baixar'),
      onClick: (e) => fuOnClickBaixarButton(formPageContainer),
      icon: icons.BAIXAR_ICON,
    }
    arrayBotoes.push(botao)
  }

  if (lancamento.status === 3 && utils.nonNull(lancamento.oid) && !lancamentoContrapartida) {
    let botao = {
      type: 'button',
      label: utils.getMessage(formPageContainer.props.messages, 'lancamentofinanceiro.label.estornar'),
      className: 'p-button-danger',
      onClick: (e) => fuEstornarLancamento([lancamento.oid], formPageContainer),
      icon: icons.TIMES_ICON,
    }
    if (formPageContainer.state.ESTORNAR_LANCAMENTO) {
      arrayBotoes.push(botao)
    }
  }

  resolveBotaoNFSe({ arrayBotoes, lancamento, formPageContainer })

  // Se tem OID e se NAO estiver PAGO
  if (
    lancamento.oid &&
    lancamento.status !== 3 &&
    !lancamentoContrapartida &&
    formPageContainer.state.ACAO_CANCELAR_LANCAMENTOS
  ) {
    let msgKey = 'lancamentofinanceiro.label.reabrir'
    let className = 'p-button-success'
    let icon = icons.UNDO
    if (lancamento.status !== 4) {
      msgKey = 'lancamentofinanceiro.label.cancelar'
      className = 'p-button-danger'
      icon = icons.TIMES_ICON
    }
    const botao = {
      type: 'button',
      label: utils.getMessage(formPageContainer.props.messages, msgKey),
      className: className,
      style: 'margin-left: 30px;',
      onClick: (e) => fuConfirmarCancelarReabrir(lancamento, formPageContainer),
      icon: icon,
    }
    arrayBotoes.push(botao)
  }

  if (lancamento.oid) {
    const botaoWhats = {
      icon: icons.WHATSAPP,
      type: 'button',
      label: 'WhatsApp',
      className: 'p-button-success',
      style: 'margin-left: 30px;',
      onClick: (e) => fuEnviarWhatsApp(lancamento.oid, formPageContainer),
    }
    arrayBotoes.push(botaoWhats)

    const botaoEmail = {
      type: 'button',
      label: 'E-mail',
      className: null,
      style: 'margin-left: 30px;',
      onClick: (e) => formPageContainer.props.enviarMensagem(lancamento.oid, enums.TipoMensagem.EMAIL),
    }
    arrayBotoes.push(botaoEmail)

    if (formPageContainer.state.ACAO_UNIR_LANCAMENTOS) {
      const botao = {
        type: 'button',
        label: 'Unir lançamentos',
        className: null,
        style: 'margin-left: 30px;',
        onClick: (e) => fuConfirmarUnirLancamento(formPageContainer),
      }
      arrayBotoes.push(botao)
    }

    if (formPageContainer.state.FECHAR_PEDIDO_STONE) {
      const msgKey = 'lancamentofinanceiro.label.fecharPedido'
      const botao = {
        type: 'button',
        label: utils.getMessage(formPageContainer.props.messages, msgKey),
        className: 'p-button-danger',
        style: 'margin-left: 30px;',
        onClick: (e) => {
          formPageContainer.setState({ showConfirmarFecharPedido: true })
        },
      }
      arrayBotoes.push(botao)
    }
    if (formPageContainer.state.ACAO_REAJUSTAR_LANCAMENTOS) {
      const msgKey = 'lancamentofinanceiro.label.reajustar'
      const botao = {
        type: 'button',
        label: utils.getMessage(formPageContainer.props.messages, msgKey),
        className: 'p-button-success',
        style: 'margin-left: 30px;',
        onClick: (e) => {
          formPageContainer.setState({ showConfirmarReajusteLancamento: true })
        },
      }
      arrayBotoes.push(botao)
    }
  }
  return arrayBotoes
}

export function fuEstornarLancamento(oidsLancamentos, formPageContainer) {
  formPageContainer.lancamentosEstornar = oidsLancamentos
  formPageContainer.setState({ showConfirmarEstornar: true })
}

export function fuConfirmarCancelarReabrir(lancamento, formPageContainer) {
  formPageContainer.setState({ showConfirmarCancelarReabrir: true })
  formPageContainer.lancamentoCancelarReabrir = lancamento
}

export function fuEnviarWhatsApp(oidLancamento, formPageContainer) {
  if (formPageContainer.props.isUsarWebWhatsapp) {
    formPageContainer.props.abrirWebWhatsApp({ oidLancamento })
  } else {
    formPageContainer.props.enviarMensagem(oidLancamento, enums.TipoMensagem.WHATSAPP)
  }
}

export function fuAtualizarProvisionamento(lancamento, formPageContainer) {
  if (lancamento && lancamento.oid) {
    const params = {
      oidLancamento: lancamento.oid,
      valorRecebido: _.get(lancamento, 'valorRecebido', null),
      dataRecebimento: _.get(lancamento, 'dataRecebimento', null),
      dataPrevisaoRecebimento: _.get(lancamento, 'dataPrevisaoRecebimento', null),
    }
    formPageContainer.props.atualizarProvisionamento(params)
  }
}

export function fuConfirmarUnirLancamento(formPageContainer) {
  formPageContainer.setState({ oidLancamentoUnir: '' })
  formPageContainer.props.showForm('unirLancamento', true)
}

function resolveBotaoNFSe({ arrayBotoes, lancamento, formPageContainer }) {
  const STATUS_NFSE_CANCELADA = 9
  const oid = _.get(lancamento, 'oid', null)
  const emiteNFSe = _.get(formPageContainer, 'props.emiteNFSe', false)
  if (oid && emiteNFSe) {
    const oidNfse = utils.isNumber(_.get(lancamento, 'oidNfse', null))
    const statusNfse = _.get(lancamento, 'statusNFSe', null)
    const isGerarNota = !oidNfse || (oidNfse && statusNfse === STATUS_NFSE_CANCELADA)
    const botao = {
      type: 'button',
      label: utils.getMessage(formPageContainer.props.messages, 'lancamentofinanceiro.label.nfse'),
      onClick: (e) =>
        isGerarNota ? formPageContainer.props.showForm('emitirNfse', true) : formPageContainer.props.downloadDanfe(oid),
      icon: isGerarNota ? icons.RECEIPT_ICON : icons.DOWNLOAD,
    }
    arrayBotoes.push(botao)
  }
}

export function fuGerarBoletoIndividual(formPageContainer) {
  let parcelasBoleto = []
  if (formPageContainer.props.selectedParcelas && formPageContainer.props.selectedParcelas.length > 0) {
    const boletos = formPageContainer.props.selectedParcelas.filter((p) => p.tipoFormaPagamento.id === 5)
    parcelasBoleto = boletos.map((b) => b.oid)
  }

  const params = {
    oidsLancamentosFinanceiros:
      parcelasBoleto.length > 1 ? parcelasBoleto : [formPageContainer.state.oidLancamentoBoletoIndividual],
    formaEmissaoEnvioCorreios: formPageContainer.state.formaEmissaoEnvioCorreios,
    enviarSmsAntesVencimento: formPageContainer.state.enviarSmsAntesVencimento,
    enviarSmsDiaVencimento: formPageContainer.state.enviarSmsDiaVencimento,
    enviarSmsDepoisVencimento: formPageContainer.state.enviarSmsDepoisVencimento,
  }
  if (parcelasBoleto.length > 1) {
    formPageContainer.props.gerarCarneBoleto(params)
  } else {
    formPageContainer.props.gerarBoletoIndividual(params)
  }
  // limpando os dados do state
  formPageContainer.setState({ oidLancamentoBoletoIndividual: null })
  formPageContainer.setState({ formaEmissaoEnvioCorreios: false })
  formPageContainer.setState({ enviarSmsAntesVencimento: false })
  formPageContainer.setState({ enviarSmsDiaVencimento: false })
  formPageContainer.setState({ enviarSmsDepoisVencimento: false })
}

export function fuGerarCarneParcelas(formPageContainer) {
  let oidsParcelas = []
  if (formPageContainer.props.selectedParcelas && formPageContainer.props.selectedParcelas.length > 0) {
    const carnes = formPageContainer.props.selectedParcelas.filter((p) => p.tipoFormaPagamento.id === 17)
    oidsParcelas = carnes.map((b) => b.oid)
    formPageContainer.props.gerarCarne(oidsParcelas)
  }
}

export function fuCancelarReabrir(formPageContainer) {
  if (formPageContainer.lancamentoCancelarReabrir && utils.isNumber(formPageContainer.lancamentoCancelarReabrir.oid)) {
    formPageContainer.props.cancelarReabrir(formPageContainer.lancamentoCancelarReabrir.oid)
  }
}

export function fuFecharPedido(formPageContainer) {
  const oid = _.get(formPageContainer, 'props.record.oid', null)
  if (oid) {
    formPageContainer.props.fecharPedidos([oid])
  }
}

export function fuReajustarLancamento({ formPageContainer, data }) {
  const lancamentos = data.lancamentos
  const percentual = data.valor
  if (_.isEmpty(lancamentos) || percentual === 0) {
    return
  }
  const oidsLancamentos = lancamentos.map((b) => b.oid)
  formPageContainer.props.reajustarLancamentos({ oidsLancamentos, percentual })
}

export function fuGetModalBaixarLancamento(formPageContainer) {
  const oid = _.get(formPageContainer, 'props.record.oid', null)
  if (!oid) {
    return null
  }
  return (
    <BaixarLancamentoDialog
      messages={formPageContainer.props.messages}
      visible={formPageContainer.props.displayForm.baixar}
      onHide={formPageContainer.onHideModalBaixarLancamento}
      lancamentosBaixar={[formPageContainer.props.record]}
      formasPagamento={formPageContainer.props.formasPagamentoBasica}
      onConfirm={formPageContainer.confirmarBaixa}
      labelBaixar={utils.getMessage(formPageContainer.props.messages, 'lancamentofinanceiro.label.baixar')}
      labelValorPago={utils.getMessage(formPageContainer.props.messages, 'lancamentofinanceiro.label.valorbaixa')}
      labelDataBaixa={utils.getMessage(formPageContainer.props.messages, 'lancamentofinanceiro.label.databaixa')}
      labelFormaPagamento={utils.getMessage(
        formPageContainer.props.messages,
        'lancamentofinanceiro.label.formapagamento'
      )}
      labelConfirmar={utils.getMessage(formPageContainer.props.messages, 'lancamentofinanceiro.label.confirmar')}
      bloquearLancamento={formPageContainer.state.BLOQUEAR_LANCAMENTO}
    />
  )
}

export function fuGetModalEmitirNFSe(formPageContainer) {
  const oid = _.get(formPageContainer, 'props.record.oid', null)
  if (!oid) {
    return null
  }
  return (
    <EmitirNfseDialog
      record={formPageContainer.props.record}
      messages={formPageContainer.props.messages}
      visible={formPageContainer.props.displayForm.emitirNfse}
      onHide={() => formPageContainer.props.showForm('emitirNfse', false)}
      onConfirm={formPageContainer.emitirNFSe}
      setField={formPageContainer.props.setField}
      statePessoaFisica={formPageContainer.props.statePessoaFisica}
      statePessoaJuridica={formPageContainer.props.statePessoaJuridica}
      history={formPageContainer.props.history}
    />
  )
}

const onConfirmBaixarLancamentos = ({
  valor,
  data,
  formaPagamento,
  lancamentos,
  desconto,
  multa,
  juros,
  oidContaCorrente,
  container,
}) => {
  const oidsLancamentos = lancamentos.map((l) => l.oid)
  const params = {
    oidsLancamentos,
    valor,
    data,
    formaPagamento,
    desconto,
    multa,
    juros,
    oidContaCorrente,
  }
  container.props.executarBaixaLancamentos(params)
  container.props.showForm('baixarParcelas', false)
  container.props.setSelectedParcelas([])
}

export function fuGetDialogDadosBaixaParcela(formPageContainer) {
  const parcelas = formPageContainer.props.selectedParcelas
  if (!parcelas || parcelas.length === 0) {
    return
  }
  return (
    <BaixarLancamentoModal
      messages={formPageContainer.props.messages}
      visible={formPageContainer.props.displayForm.baixarParcelas}
      onHide={(e) => formPageContainer.props.showForm('baixarParcelas', false)}
      lancamentosBaixar={parcelas}
      formasPagamento={formPageContainer.props.formasPagamentoBasica}
      onConfirm={onConfirmBaixarLancamentos}
      labelBaixar={utils.getMessage(formPageContainer.props.messages, 'lancamentofinanceiro.label.baixar')}
      labelValorPago={utils.getMessage(formPageContainer.props.messages, 'lancamentofinanceiro.label.valorbaixa')}
      labelDataBaixa={utils.getMessage(formPageContainer.props.messages, 'lancamentofinanceiro.label.databaixa')}
      labelContaCorrente={utils.getMessage(
        formPageContainer.props.messages,
        'lancamentofinanceiro.label.contacorrente'
      )}
      labelDesconto={utils.getMessage(formPageContainer.props.messages, 'lancamentofinanceiro.label.desconto')}
      labelMulta={utils.getMessage(formPageContainer.props.messages, 'lancamentofinanceiro.label.multa')}
      labelJuros={utils.getMessage(formPageContainer.props.messages, 'lancamentofinanceiro.label.juros')}
      labelConfirmar={utils.getMessage(formPageContainer.props.messages, 'lancamentofinanceiro.label.confirmar')}
      labelConfirmarBaixaParcial={utils.getMessage(
        formPageContainer.props.messages,
        'lancamentofinanceiro.label.confirmaBaixaParcial'
      )}
      bloquearLancamento={formPageContainer.state.BLOQUEAR_LANCAMENTO} // verirficar isso
      descontosMultasJuros={formPageContainer.props.descontosMultasJuros}
      isGerarLancamentoSaldo={this.props.isGerarLancamentoSaldo}
      container={formPageContainer}
    />

    // <Dialog
    //     header={utils.getMessage(formPageContainer.props.messages, 'lancamentofinanceiro.label.baixarparcelas')}
    //     visible={formPageContainer.props.displayForm.baixarParcelas}
    //     style={{ width: '50vw' }}
    //     onHide={(e) => formPageContainer.props.showForm('baixarParcelas', false)}
    //     baseZIndex={1000000}
    //     modal={true}
    //     closable={true}
    //   >
    //     <div className="p-grid p-fluid">
    //       <div className="p-grid form-group p-align-end">
    //         <div className="p-col-12 p-sm-12 p-md-6 p-lg-6 p-xl-6">
    //           <label className="label">
    //             {utils.getMessage(formPageContainer.props.messages, 'lancamentofinanceiro.label.valor')}
    //           </label>
    //           {/*FIXME*/}
    //           <label className="label">{` R$ ${utils.formatCurrency(
    //             getValorLancamentosSelecionados(formPageContainer)
    //           )}`}</label>
    //         </div>
    //
    //         <div className="p-col-12 p-sm-12 p-md-6 p-lg-6 p-xl-6">
    //           <label className="label">
    //             {utils.getMessage(formPageContainer.props.messages, 'lancamentofinanceiro.label.databaixa')}
    //           </label>
    //           <Calendar
    //             yearNavigator={true}
    //             yearRange={utils.getYearRangeFromNow()}
    //             monthNavigator={true}
    //             value={lancamento.dataPagamentoParcela}
    //             onChange={formPageContainer.props.changeHandler}
    //             name="dataPagamentoParcela"
    //           />
    //         </div>
    //       </div>
    //     </div>
    //     <div className="p-grid form-group">
    //       <div className="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12">
    //         <Button
    //           label={utils.getMessage(formPageContainer.props.messages, 'lancamentofinanceiro.label.confirmar')}
    //           onClick={(e) => {
    //             fuRealizarBaixaLancamentosFilhos(formPageContainer)
    //             formPageContainer.props.showForm('baixarParcelas', false)
    //           }}
    //           icon={icons.CHECK_ICON}
    //           className="p-button-success"
    //         />
    //       </div>
    //     </div>
    //   </Dialog>
  )
}

const getValorLancamentosSelecionados = (formPageContainer) => {
  let valorTotalLancamentoSelecionados = 0
  if (formPageContainer.props.selectedParcelas && formPageContainer.props.selectedParcelas.length >= 1) {
    formPageContainer.props.selectedParcelas.forEach((lancamentoSelecionado) => {
      let valor = utils.parseStringToNumber(lancamentoSelecionado.valor)
      valorTotalLancamentoSelecionados += valor
    })
  }
  return valorTotalLancamentoSelecionados
}

// DIALOG REABRIR
export function fuGetDialogCancelarReabrir(formPageContainer) {
  if (formPageContainer.state.showConfirmarCancelarReabrir) {
    let msgKey = 'lancamentofinanceiro.dialog.message.confirmarReabrir'
    if (formPageContainer.lancamentoCancelarReabrir.status !== 4) {
      msgKey = 'lancamentofinanceiro.dialog.message.confirmarCancelar'
    }
    return (
      <ConfirmDialog
        header={utils.getMessage(formPageContainer.props.messagesDialog, 'dialog.titulo.confirmacao')}
        visible={formPageContainer.state.showConfirmarCancelarReabrir}
        content={utils.getMessage(formPageContainer.props.messagesDialog, msgKey)}
        confirm={() => fuCancelarReabrir(formPageContainer)}
        hideDialog={() => fuHideDialog(formPageContainer)}
      />
    )
  }
  return null
}

export function fuGetDialogConfirmarFecharPedido(formPageContainer) {
  if (formPageContainer.state.showConfirmarFecharPedido) {
    const msgKey = 'lancamentofinanceiro.dialog.message.confirmar.fecharPedido'
    return (
      <ConfirmDialog
        visible={formPageContainer.state.showConfirmarFecharPedido}
        content={utils.getMessage(formPageContainer.props.messagesDialog, msgKey)}
        confirm={() => fuFecharPedido(formPageContainer)}
        hideDialog={() => fuHideDialog(formPageContainer)}
      />
    )
  }
  return null
}

export function fuGetDialogConfirmarReajustarLancamento(formPageContainer) {
  if (formPageContainer.state.showConfirmarReajusteLancamento) {
    return (
      <ReajustarLancamentoDialog
        visible={formPageContainer.state.showConfirmarReajusteLancamento}
        onHide={() => fuHideDialog(formPageContainer)}
        lancamentosReajustar={[formPageContainer.props.record] || []}
        onConfirm={(e) => fuReajustarLancamento({ formPageContainer, data: e })}
        title={utils.getMessage(formPageContainer.props.messages, 'lancamentofinanceiro.label.reajustarLancamento')}
        labelPercentualReajuste={utils.getMessage(
          formPageContainer.props.messages,
          'lancamentofinanceiro.label.percentualReajuste'
        )}
        labelConfirmar={utils.getMessage(formPageContainer.props.messages, 'lancamentofinanceiro.label.confirmar')}
      />
    )
  }
  return null
}

// DIALOG DADOS BOLETO INDIVIDUAL
export function fuGetDialogDadosBoletoIndividual(formPageContainer) {
  return (
    <Dialog
      header={utils.getMessage(formPageContainer.props.messages, 'lancamentofinanceiro.label.dadosenviocontrato')}
      visible={formPageContainer.props.displayForm.dadosBoletoIndividual}
      style={{ width: '50vw' }}
      onHide={(e) => formPageContainer.props.showForm('dadosBoletoIndividual', false)}
      baseZIndex={1000000}
      modal={true}
      closable={true}
    >
      <div className="p-grid p-fluid">
        <div className="p-grid form-group p-align-end">
          <div className="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12">
            <Checkbox
              inputId="chkEnviarPorCorreios"
              checked={formPageContainer.state.formaEmissaoEnvioCorreios}
              onChange={(e) => formPageContainer.setState({ formaEmissaoEnvioCorreios: e.checked })}
              name="formaEmissaoEnvioCorreios"
            />
            <label htmlFor="chkEnviarPorCorreios" className="p-checkbox-label">
              {utils.getMessage(formPageContainer.props.messages, 'lancamentofinanceiro.label.enviarporcorreios')}
            </label>
          </div>
          <div className="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12">
            <Checkbox
              inputId="chkenviarSmsAntesVencimento"
              checked={formPageContainer.state.enviarSmsAntesVencimento}
              onChange={(e) => formPageContainer.setState({ enviarSmsAntesVencimento: e.checked })}
              name="enviarSmsAntesVencimento"
            />
            <label htmlFor="chkenviarSmsAntesVencimento" className="p-checkbox-label">
              {utils.getMessage(
                formPageContainer.props.messages,
                'lancamentofinanceiro.label.enviarsmsantesvencimento'
              )}
            </label>
          </div>
          <div className="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12">
            <Checkbox
              inputId="chkenviarSmsDiaVencimento"
              checked={formPageContainer.state.enviarSmsDiaVencimento}
              onChange={(e) => formPageContainer.setState({ enviarSmsDiaVencimento: e.checked })}
              name="enviarSmsDiaVencimento"
            />
            <label htmlFor="chkenviarSmsDiaVencimento" className="p-checkbox-label">
              {utils.getMessage(
                formPageContainer.props.messages,
                'lancamentofinanceiro.label.enviarsmsnodiavencimento'
              )}
            </label>
          </div>
          <div className="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12">
            <Checkbox
              inputId="chkenviarSmsDepoisVencimento"
              checked={formPageContainer.state.enviarSmsDepoisVencimento}
              onChange={(e) => formPageContainer.setState({ enviarSmsDepoisVencimento: e.checked })}
              name="enviarSmsDepoisVencimento"
            />
            <label htmlFor="chkenviarSmsDepoisVencimento" className="p-checkbox-label">
              {utils.getMessage(
                formPageContainer.props.messages,
                'lancamentofinanceiro.label.enviarsmsdepoisvencimento'
              )}
            </label>
          </div>

          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12">
              <Button
                label={utils.getMessage(formPageContainer.props.messages, 'lancamentofinanceiro.label.confirmar')}
                onClick={(e) => {
                  fuGerarBoletoIndividual(formPageContainer)
                  formPageContainer.props.showForm('dadosBoletoIndividual', false)
                }}
                icon={icons.CHECK_ICON}
                className="p-button-success"
              />
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  )
}

//DIALOG ESTORNAR
export function fuGetDialogEstornar(formPageContainer) {
  if (formPageContainer.state.showConfirmarEstornar) {
    let msgKey = 'lancamentofinanceiro.dialog.message.confirmar.estorno'
    const lancamento = formPageContainer.props.record
    if (utils.isArrayNotEmpty(lancamento.lancamentos)) {
      msgKey = 'lancamentofinanceiro.dialog.message.confirmar.estorno.lancamento.pai'
    }

    return (
      <ConfirmDialog
        visible={formPageContainer.state.showConfirmarEstornar}
        content={utils.getMessage(formPageContainer.props.messagesDialog, msgKey)}
        confirm={() => formPageContainer.props.estornarLancamento(formPageContainer.lancamentosEstornar)}
        hideDialog={() => fuHideDialog(formPageContainer)}
      />
    )
  }
  return null
}

//DIALOG ESTORNAR PARCELAS
export function fuGetDialogEstornarParcelas(formPageContainer) {
  if (formPageContainer.state.showConfirmarEstornarParcelas) {
    return (
      <ConfirmDialog
        visible={formPageContainer.state.showConfirmarEstornarParcelas}
        content={utils.getMessage(
          formPageContainer.props.messagesDialog,
          'lancamentofinanceiro.dialog.message.confirmar.estorno.parcelas'
        )}
        confirm={() => executarEstornoParcelas(formPageContainer)}
        hideDialog={() => fuHideDialog(formPageContainer)}
      />
    )
  }
  return null
}

const executarEstornoParcelas = (formPageContainer) => {
  let pagamentosEstornados = []
  formPageContainer.props.selectedParcelas.forEach((lancamento) => {
    pagamentosEstornados.push(lancamento.oid)
  })
  formPageContainer.props.estornarLancamento(pagamentosEstornados)
}

//DIALOG UNIR LANCAMENTO
export function fuGetDialogUnirLancamento(formPageContainer) {
  const footer = (
    <div>
      <Button
        label={utils.getMessage(formPageContainer.props.messages, 'lancamentofinanceiro.label.confirmar')}
        onClick={(e) => {
          executarUnirLancamento(formPageContainer)
          formPageContainer.props.showForm('unirLancamento', false)
        }}
        icon={icons.CHECK_ICON}
        className="p-button-success"
      />
    </div>
  )
  return (
    <Dialog
      header={utils.getMessage(formPageContainer.props.messages, 'lancamentofinanceiro.label.unir.lancamento')}
      visible={formPageContainer.props.displayForm.unirLancamento}
      style={{ width: '20vw' }}
      onHide={(e) => {
        formPageContainer.props.showForm('unirLancamento', false)
        formPageContainer.setState({ oidLancamentoUnir: 0 })
      }}
      baseZIndex={1000000}
      modal={true}
      closable={true}
      footer={footer}
    >
      <div className="margin-top-dialogs">
        <span className="p-float-label">
          <InputText
            keyfilter={/^[0-9.,]+$/}
            value={formPageContainer.state.oidLancamentoUnir}
            maxLength={10}
            onChange={(e) => {
              formPageContainer.setState({ oidLancamentoUnir: e.target.value })
            }}
            name="oidLancamentoUnir"
          />
          <label className="label">
            {utils.getMessage(formPageContainer.props.messages, 'lancamentofinanceiro.label.lancamento.excluir')}
          </label>
        </span>
      </div>
    </Dialog>
  )
}

const executarUnirLancamento = (formPageContainer) => {
  const oidExcluir = parseInt(formPageContainer.state.oidLancamentoUnir)
  formPageContainer.props.unirLancamentos(formPageContainer.props.record.oid, oidExcluir)
  formPageContainer.setState({ oidLancamentoUnir: '' })
}

export function fuOnClickBaixarLancamentos(formPageContainer) {
  const parcelas = formPageContainer.props.selectedParcelas
  const oids = parcelas.map((lancamento) => lancamento.oid)
  formPageContainer.props.getDescontosMultasJuros(oids)
  // o Dialog sera exibido no callback de 'actions.getDescontosMultasJuros'
}

// RENDER //
